import { useEffect, useState } from "react";
import { pWorkItemRelationType, workItemRelationType, workItemTypes } from "../../store/api/CommonFunctions";
import SearchableSelect from "../../Components/SearchableSelect";
import { Button, Col, Row, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faPencilAlt, faPlus, faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";
import { getByTypeAndNumber } from "../store/api/workItemsApi";
import { useForm } from "react-hook-form";
/**
 * @typedef WorkItemRelation
 * @property {number} ID
 * @property {workItemRelationType} RelationType
 * @property {number} SourceWorkItemID
 * @property {string} SourceWorkItemNumber
 * @property {number} TargetWorkItemID
 * @property {string} TargetWorkItemNumber
 */
/**
 * 
 * @param {[WorkItemRelation]} relations 
 * @param {function} onChange
 * @param {workItemTypes} type
 */
export default function WorkItemRelations({ relations, onChange, type, control }) {

    const [relationsClone, setRelationsClone] = useState(relations ?? []);
    const [currentRelation, setCurrentRelation] = useState(null);
    const [workItems, setWorkItems] = useState();

    const handleSearchSelectChange = async (number) => {
        if (Number(currentRelation.ID) > 0) {
            return
        }
        const result = await getByTypeAndNumber(type, number);
        if (result?.Data) {
            return result?.Data.map(r => ({
                value: r.ID,
                label: r.Number
            }));
        }
    }
    const handleTypeChange = (e) => {
        const rType = Number(e.target.value);
        setCurrentRelation(prev =>
        ({
            ...prev,
            RelationType: rType,
            PRelationType: pWorkItemRelationType[rType - 1]
        }));
    }
    const handleNumberSelect = (opt) => {
        setCurrentRelation(prev => (
            {
                ...prev,
                TargetWorkItemID: opt.value,
                TargetWorkItemNumber: opt.label
            }
        ))
    }
    const handleCancel = () => {
        setCurrentRelation(null);
    }
    const handleAdd = () => {
        setCurrentRelation({
            Indx: crypto.randomUUID()
        })
    }
    const handleUpdate = (relation) => {
        setCurrentRelation(prev => ({ ...relation }));
    }
    const handleRemove = (relation) => {

        setRelationsClone(prev => {
            const newRelations = prev.filter(r => r.Indx !== relation.Indx);
            onChange?.(newRelations);
            return newRelations;
        }
        );

    }
    const handleSubmit = () => {
        if(!currentRelation.RelationType || !currentRelation.TargetWorkItemID)
        {
            return;
        }
        setRelationsClone(prev => {
            const index = prev.findIndex(r => r.Indx === currentRelation.Indx);

            let newRelations;

            if (index >= 0) {
                newRelations = prev.map(r =>
                    r.Indx === currentRelation.Indx ? { ...currentRelation } : r
                );
            } else {
                newRelations = [...prev, { ...currentRelation }];
            }

            onChange?.(newRelations);
            return newRelations;
        });
        if (Number(currentRelation.ID) > 0) {
            setCurrentRelation(null);
        }
        else {
            handleAdd();
        }
    };


    useEffect(() => {
        setRelationsClone(
            (relations ?? []).map(
                r => ({
                    ...r,
                    Indx: crypto.randomUUID()
                })
            )
        );

    }, [relations])



    return (
        <>
            {currentRelation &&
                <Row>
                    <Col md={2} className="form-group">
                        <label>نوع ارتباط:</label>
                        <select className="form-control" autoFocus onChange={handleTypeChange} value={currentRelation.RelationType??""}>
                            <option value="">
                                انتخاب کنید
                            </option>
                            <option value={workItemRelationType.parent}>والد/زیرمجموعه</option>
                            <option value={workItemRelationType.dependsOn}>وابسته</option>
                            <option value={workItemRelationType.blocks}>مسدودکننده</option>
                            <option value={workItemRelationType.related}>مرتبط</option>
                            <option value={workItemRelationType.duplicate}>تکراری</option>
                            <option value={workItemRelationType.sprint}>اسپرینت</option>
                            <option value={workItemRelationType.release}>انتشار</option>
                            <option value={workItemRelationType.milestone}>نقطه عطف</option>
                        </select>
                    </Col>
                    <Col md={2} className="form-group">
                        <label>شماره کار:</label>
                        <SearchableSelect
                            value={currentRelation.TargetWorkItemID??0}
                            defaultLabel={currentRelation.TargetWorkItemNumber??""}
                            name="TargetWorkItemID"
                            control={control}
                            placeholder="جستجوی شماره کار..."

                            loadOptions={handleSearchSelectChange}

                            onChange={handleNumberSelect}
                        />
                    </Col>
                    <Col md={2} className="d-flex gap-1" style={{ flexWrap: "wrap", alignContent: "end" }}>
                        <Button variant="outline-success" onClick={handleSubmit}>
                            <FontAwesomeIcon icon={faCheck} />
                        </Button>
                        <Button variant="outline-danger" onClick={handleCancel}>
                            <FontAwesomeIcon icon={faTimes} />
                        </Button>
                    </Col>
                </Row>
            }
            <Row>
                <Col md={6}>
                    {!currentRelation && <Button  className="mt-2" variant="outline-success" onClick={handleAdd}><FontAwesomeIcon icon={faPlus} /></Button>}
                    <Table className="designedTable mt-1" style={{ "--rowColor": "#f9defa91" }}>
                        <thead style={{ backgroundColor: "#9fa3db" }}>
                            <tr>
                                <th>نوع ارتباط</th>
                                <th>شماره کار</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {(relationsClone ?? []).map((rel, i) =>
                                <tr key={i}>
                                    <td>{rel.PRelationType}</td>
                                    <td>{rel.TargetWorkItemNumber}</td>
                                    <td>
                                        <div className="d-flex gap-1">
                                            {/* <FontAwesomeIcon icon={faPencilAlt} color="orange" onClick={() => handleUpdate(rel)} /> */}
                                            <FontAwesomeIcon icon={faTrash} color="red" onClick={() => handleRemove(rel)} />
                                        </div>
                                    </td>
                                </tr>)}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </>
    )
}